import React from "react"
import types from "prop-types"
import { questionShape } from "utils/propTypeShapes"
import { QuestionSelect } from "shared/selects"

const NumberQuestionSelect = ({
  questions, selectLabel = "select a number question", selectedQuestionUuid, onChange, ...rest
}) => (
  <QuestionSelect
    questions={questions}
    selectedQuestionUuid={selectedQuestionUuid}
    backspaceDelete={false}
    onChange={onChange}
    selectLabel={selectLabel}
    {...rest}
  />
)

NumberQuestionSelect.propTypes = {
  questions: types.arrayOf(questionShape).isRequired,
  selectLabel: types.string,
  selectedQuestionUuid: types.string.isRequired,
  onChange: types.func.isRequired,
}

export default NumberQuestionSelect
